// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__073SJ","medium":"Icon_medium__L99ml","small":"Icon_small__yG8BW","large":"Icon_large__Ap8qW","inherit":"Icon_inherit__JpTaz"};